import type { ID } from '@octopus-do/octopus-project-core'
import { DashboardActions } from '@store/reducers/dashboard/actions'
import type React from 'react'
import { useDispatch } from 'react-redux'

import { FolderInput } from '../../../../../FolderInput'

interface Props {
  title: string
  workspaceId: ID
  id: ID
  onHideRenameInput: () => void
}

export const FolderRename: React.FC<Props> = ({
  title,
  workspaceId,
  id,
  onHideRenameInput,
}) => {
  const dispatch = useDispatch()

  const handleRenameFolder = (value: string) => {
    if (!workspaceId || !value) {
      return
    }

    if (value === title) {
      return
    }

    dispatch(DashboardActions.folders.rename({ workspaceId, id, title: value }))
  }

  return (
    <FolderInput
      title={title}
      onSubmit={(value) => {
        handleRenameFolder(value)
        onHideRenameInput()
      }}
    />
  )
}
